import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  iconAlt: {
    id: 'studio.J0xFmK',
    defaultMessage: 'Appsemble logo',
  },
  login: {
    id: 'studio.AyGauy',
    defaultMessage: 'Login',
  },
});
